import AbstractRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AbstractRuleSpecification'

export default class IsResponseError extends AbstractRuleSpecification {
  constructor () {
    super()

    this._reasonNotSatisfied = 'Response отсутствует'
  }

  /**
   * https://www.npmjs.com/package/axios#handling-errors
   *
   * The request was made and the server responded with a status code that falls out of the range of 2xx
   *
   * @param response
   * @returns {boolean}
   * @private
   */
  _executeCheckIsSatisfiedBy (response) {
    return !!response
  }
}
